import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, X } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-semibold text-gray-900 mb-3">Product</h3>
            <ul className="space-y-2">
              <li><Link to="/features" className="text-gray-600 hover:text-primary transition">Features</Link></li>
              <li><Link to="/pricing" className="text-gray-600 hover:text-primary transition">Pricing</Link></li>
              <li><Link to="/whats-new" className="text-gray-600 hover:text-primary transition">What's New</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-3">Industries</h3>
            <ul className="space-y-2">
              <li><Link to="/dance-studios" className="text-gray-600 hover:text-primary transition">Dance Studios</Link></li>
              <li><Link to="/summer-camps" className="text-gray-600 hover:text-primary transition">Summer Camps</Link></li>
              <li><Link to="/swim-classes" className="text-gray-600 hover:text-primary transition">Swim Classes</Link></li>
              <li><Link to="/music-schools" className="text-gray-600 hover:text-primary transition">Music Schools</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-3">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/our-why" className="text-gray-600 hover:text-primary transition">Our Why</Link></li>
              <li><Link to="/blog" className="text-gray-600 hover:text-primary transition">Blog</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-primary transition">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-3">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/terms-of-service" className="text-gray-600 hover:text-primary transition">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-gray-600 hover:text-primary transition">Privacy Policy</Link></li>
              <li><Link to="/cookies" className="text-gray-600 hover:text-primary transition">Cookie Policy</Link></li>
              <li><Link to="/eula" className="text-gray-600 hover:text-primary transition">EULA</Link></li>
              <li><a href="#" className="termly-display-preferences text-gray-600 hover:text-primary transition">Cookie Preferences</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
          <div className="text-gray-600 order-1 lg:order-1">
            © {new Date().getFullYear()} Hivetivity. All rights reserved.
          </div>
          <div className="text-gray-600 text-center flex items-center justify-center gap-2 order-2 lg:order-2">
            <span className="text-xl mr-2">🇺🇸</span>
            <span>Hivetivity is proudly developed and supported in the USA. We welcome users from across the world.</span>
          </div>
          <div className="flex space-x-6 order-3 lg:order-3">
            <a href="https://www.facebook.com/myhivetivity" target="_blank" rel="noopener noreferrer" className="group relative text-gray-500 hover:text-white transition">
              <span className="sr-only">Facebook</span>
              <span className="absolute inset-0 rounded-full bg-gradient-to-tr from-blue-500 to-blue-300 opacity-0 group-hover:opacity-80 transition-opacity duration-300 z-0 scale-95 group-hover:scale-110 group-hover:shadow-lg"></span>
              <Facebook className="relative h-5 w-5 z-10 transition-transform duration-300 group-hover:scale-110" />
            </a>
            <a href="https://www.instagram.com/hivetivity/" target="_blank" rel="noopener noreferrer" className="group relative text-gray-500 hover:text-white transition">
              <span className="sr-only">Instagram</span>
              <span className="absolute inset-0 rounded-full bg-gradient-to-tr from-pink-500 via-yellow-400 to-purple-500 opacity-0 group-hover:opacity-80 transition-opacity duration-300 z-0 scale-95 group-hover:scale-110 group-hover:shadow-lg"></span>
              <Instagram className="relative h-5 w-5 z-10 transition-transform duration-300 group-hover:scale-110" />
            </a>
            <a href="https://x.com/myhivetivity" target="_blank" rel="noopener noreferrer" className="group relative text-gray-500 hover:text-white transition">
              <span className="sr-only">X</span>
              <span className="absolute inset-0 rounded-full bg-gradient-to-tr from-gray-800 to-gray-600 opacity-0 group-hover:opacity-80 transition-opacity duration-300 z-0 scale-95 group-hover:scale-110 group-hover:shadow-lg"></span>
              <X className="relative h-5 w-5 z-10 transition-transform duration-300 group-hover:scale-110" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
